module.exports = "../../static/img/logo.9463a11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jpg/logo.png
// module id = hyjs
// module chunks = 1